import { generatePath } from 'react-router-dom';
import { MY_PLAYLISTS_URL_FRAGMENT } from '../../constants/Navigation';
export const getMyPlaylistsUrl = ({
  tab,
  page
}) => {
  return generatePath(`${MY_PLAYLISTS_URL_FRAGMENT}/:tab?${page ? tab ? '/page/:page' : 'page/:page' : ''}`, {
    tab,
    page
  });
};